<template>
  <component
    :is="tag"
    v-on="$listeners"
    :class="{
      'chat-contact-active': isActive,
      'chat-contact-unread': user.hasUnread && !isActive,
    }"
    class="chat-contact"
  >
    <b-avatar
      size="42"
      :src="user.avatar"
      :badge="isChatContact"
      class="badge-minimal"
      badge-variant="success"
      variant="light-dark"
    >
      <feather-icon v-if="!user.avatar" icon="UserIcon" size="42" />
    </b-avatar>
    <div class="chat-info flex-grow-1">
      <h5
        class="mb-0 chat-contact-name"
        :class="{ 'font-weight-bold': user.hasUnread && !isActive }"
      >
        {{ user.fullName }}
      </h5>
      <p class="card-text text-truncate">
        <small
          class="float-right mb-25 chat-time"
          :class="{ 'unread-time': user.hasUnread && !isActive }"
        >
          <span
            v-if="user.hasUnread && !isActive"
            class="unread-dot"
            :title="$t('pages.chat.pendingToRead')"
            :aria-label="$t('pages.chat.pendingToRead')"
          ></span>
          {{ formatDateToMonth(user.date) }}
        </small>

        <!-- {{ isChatContact ? user.chat.lastMessage.message : '...' }} -->
      </p>
    </div>
    <div v-if="isChatContact" class="chat-meta text-nowrap">
      <small class="float-right mb-25 chat-time">{{
        formatDateToMonth(user.chat.lastMessage.time)
      }}</small>
      <b-badge
        v-if="user.chat.unseenMsgs"
        pill
        variant="light-success"
        class="float-right"
      >
        {{ user.chat.unseenMsgs }}
      </b-badge>
    </div>
  </component>
</template>

<script>
import { BAvatar, BBadge } from "bootstrap-vue";
import { formatDateToMonthShort } from "@core/utils/filter";
import useChat from "./useChat";
import * as moment from "moment";
import "moment/locale/es";
import "moment-timezone";

export default {
  components: {
    BAvatar,
    BBadge,
  },
  props: {
    tag: {
      type: String,
      default: "div",
    },
    user: {
      type: Object,
      required: true,
    },
    isChatContact: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { resolveAvatarBadgeVariant } = useChat();
    return { formatDateToMonthShort, resolveAvatarBadgeVariant };
  },

  methods: {
    formatDateToMonth(date) {
      if (!date) return "";

      const locale = this.$i18n.locale || "es";
      const today = moment().locale(locale).tz("America/Caracas");
      const inputDate = moment.utc(date).locale(locale).tz("America/Caracas");
      if (!inputDate.isValid()) return "";

      if (inputDate.isSame(today, "day")) {
        // Si la fecha coincide con hoy
        return inputDate.format("hh:mm A");
      } else if (inputDate.isSame(today.clone().subtract(1, "day"), "day")) {
        // Si la fecha fue ayer
        return this.$t("pages.chat.yesterday");
      } else if (inputDate.isSame(today, "week")) {
        // Si la fecha está dentro de la misma semana
        return inputDate.format("dddd"); // Devuelve el día de la semana (e.g., 'lunes')
      } else {
        // Si la fecha no coincide ni con hoy ni con ayer
        return inputDate.format("DD/MM/YYYY");
      }
      // return moment.utc(date).tz('America/Caracas').format('hh:mm A')
    },
  },
};

// return this.$options.filters.formatDateToMonthShort(date, options)
</script>

<style lang="scss">
.chat-contact-active {
  background-color: #f0f0f0; /* o el color que prefieras */
  border-left: 3px solid #00c851;
}

.chat-contact-unread {
  background-color: rgba(40, 116, 240, 0.08);
  border-left: 3px solid #2874f0;
}

.chat-contact-unread:hover {
  background-color: rgba(40, 116, 240, 0.13);
}

.chat-contact-unread .chat-contact-name,
.chat-contact-unread .unread-time {
  color: #2874f0;
}

.unread-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 6px;
  border-radius: 50%;
  background-color: #2874f0;
  box-shadow: 0 0 0 3px rgba(40, 116, 240, 0.12);
}

</style>
